import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {questionDbSchema} from './questionDbSchema';

/** Output schema for question (id from document id; createdAt as Date). */
export const questionSchema = questionDbSchema.extend({
  id: z.string(),
  createdAt: firestoreTimestampToDateSchema,
});

export interface Question extends z.infer<typeof questionSchema> {}
